export const PURCHASE_POST = 'PURCHASE_POST';
export const PURCHASE_ATTEMPT = 'PURCHASE_ATTEMPT';
export const PURCHASE_SUCCESSFUL_POST = 'PURCHASE_SUCCESSFUL_POST';

export const PURCHASE_ERROR_RESPONSE = 'PURCHASE_ERROR_RESPONSE';
export const PURCHASE_3D = 'PURCHASE_3D';
export const PURCHASE_3D_ERROR_RESPONSE = 'PURCHASE_3D_ERROR_RESPONSE';
export const PURCHASE_CLEAR_ERROR_RESPONSE = 'PURCHASE_CLEAR_ERROR_RESPONSE';

export const PURCHASE_GET_LATEST_CARD_INFO_RESPONSE = 'PURCHASE_GET_LATEST_CARD_INFO_RESPONSE';
export const PURCHASE_GET_PAYMENT_METHODS = 'PURCHASE_GET_PAYMENT_METHODS';
export const PURCHASE_GET_PAYMENT_METHODS_RESPONSE = 'PURCHASE_GET_PAYMENT_METHODS_RESPONSE';
export const PURCHASE_GET_PAYMENT_METHODS_ERROR_RESPONSE =
  'PURCHASE_GET_PAYMENT_METHODS_ERROR_RESPONSE';
export const PURCHASE_GET_PAYMENT_METHODS_CLEAR_LOADING =
  'PURCHASE_GET_PAYMENT_METHODS_CLEAR_LOADING';

export const PURCHASE_FORM_VALIDATION = 'purchase/PURCHASE_FORM_VALIDATION';
export const PURCHASE_UPDATE_FORM = 'purchase/PURCHASE_UPDATE_FORM';

export const PURCHASE_ADD_CART = 'PURCHASE_ADD_CART';
export const PURCHASE_REMOVE_PAYWALL_SOURCE = 'PURCHASE_REMOVE_PAYWALL_SOURCE';

export const PURCHASE_GET_TAX = 'PURCHASE_GET_TAX';
export const PURCHASE_GET_TAX_DETAILS_RESPONSE = 'PURCHASE_GET_TAX_DETAILS_RESPONSE';
export const PURCHASE_CLEAR_TAX_DETAILS = 'PURCHASE_CLEAR_TAX_DETAILS';

export const PURCHASE_ENABLE_AUTORENEW = 'PURCHASE_ENABLE_AUTORENEW';
export const PURCHASE_ENABLE_AUTORENEW_RESPONSE = 'PURCHASE_ENABLE_AUTORENEW_RESPONSE';
export const PURCHASE_DISABLE_AUTORENEW = 'PURCHASE_DISABLE_AUTORENEW';
export const PURCHASE_DISABLE_AUTORENEW_RESPONSE = 'PURCHASE_DISABLE_AUTORENEW_RESPONSE';

export const PURCHASE_UPDATE_LATEST_CARD = 'PURCHASE_UPDATE_LATEST_CARD';
export const PURCHASE_UPDATE_LATEST_CARD_RESPONSE = 'PURCHASE_UPDATE_LATEST_CARD_RESPONSE';
export const PURCHASE_UPDATE_LATEST_CARD_ERR_RESPONSE = 'PURCHASE_UPDATE_LATEST_CARD_ERR_RESPONSE';
export const PURCHASE_UPDATE_LATEST_CARD_CLEAR_ERR_RESPONSE =
  'PURCHASE_UPDATE_LATEST_CARD_CLEAR_ERR_RESPONSE';
export const PURCHASE_UPDATE_LATEST_CARD_CLEAR_SUCCESS =
  'PURCHASE_UPDATE_LATEST_CARD_CLEAR_SUCCESS';
export const PURCHASE_SAVE_BRAINTREE_PAYMENT_METHOD = 'PURCHASE_SAVE_BRAINTREE_PAYMENT_METHOD';
export const PURCHASE_DELETE_BRAINTREE_PAYMENT_METHOD = 'PURCHASE_DELETE_BRAINTREE_PAYMENT_METHOD';
export const PURCHASE_SET_PAYMENT_SDK_LOADING = 'PURCHASE_SET_PAYMENT_SDK_LOADING';

export const PURCHASE_DELETE_SAVED_CARD = 'PURCHASE_DELETE_SAVED_CARD';

export const PURCHASE_RESTORE_ACCOUNT = 'PURCHASE_RESTORE_ACCOUNT';
export const PURCHASE_RESTORE_ACCOUNT_RESPONSE = 'PURCHASE_RESTORE_ACCOUNT_RESPONSE';
export const PURCHASE_RESTORE_ACCOUNT_ERROR_RESPONSE = 'PURCHASE_RESTORE_ACCOUNT_ERROR_RESPONSE';
export const PURCHASE_RESTORE_ACCOUNT_CLEAR_ERROR_RESPONSE =
  'PURCHASE_RESTORE_ACCOUNT_CLEAR_ERROR_RESPONSE';

export const PURCHASE_UPDATE_EMAIL = 'PURCHASE_UPDATE_EMAIL';
export const PURCHASE_UPDATE_EMAIL_SUCCESS = 'PURCHASE_UPDATE_EMAIL_SUCCESS';
export const PURCHASE_UPDATE_EMAIL_ERROR_RESPONSE = 'PURCHASE_UPDATE_EMAIL_ERROR_RESPONSE';
export const PURCHASE_UPDATE_EMAIL_CLEAR_ERROR_RESPONSE =
  'PURCHASE_UPDATE_EMAIL_CLEAR_ERROR_RESPONSE';

export const SET_CHECKOUT_PAGE_TYPE = 'purchase/SET_CHECKOUT_PAGE_TYPE';
export const SET_CHECKOUT_PAGE_VERSION = 'purchase/SET_CHECKOUT_PAGE_VERSION';
export const SET_PAYMENT_METHOD = 'purchase/SET_PAYMENT_METHOD';
export const SET_CC_TYPE = 'purchase/SET_CC_TYPE';
export const SET_3DS_TYPE = 'purchase/SET_3DS_TYPE';
export const SET_UPSELL_SHOWN = 'purchase/SET_UPSELL_SHOWN';
export const SET_SAVE_CARD_BOX = 'purchase/SET_SAVE_CARD_BOX';
export const USE_BOUNCER_BYPASS = 'purchase/USE_BOUNCER_BYPASS';
export const SET_ADYEN_DEVICE_FINGERPRINT = 'purchase/SET_ADYEN_DEVICE_FINGERPRINT';
export const SET_BRAINTREE_DEVICE_FINGERPRINT = 'purchase/SET_BRAINTREE_DEVICE_FINGERPRINT';

export const SET_BRAINTREE_CLIENT_TOKEN = 'purchase/SET_BRAINTREE_CLIENT_TOKEN';
export const SET_BRAINTREE_ERROR = 'purchase/SET_BRAINTREE_ERROR';

// Need both card and credit_card
// Card is used in payment-methods, and credit_card is used in offerings
export const PAYMENT_TYPE_CARD = 'card';
export const PAYMENT_TYPE_CREDIT_CARD = 'credit_card';
export const PAYMENT_TYPE_PAYPAL = 'paypal';

export const PAYMENT_PLATFORM_CARD_OLD = 'web';
export const PAYMENT_PLATFORM_CARD = 'web_adyen_card';
export const PAYMENT_PLATFORM_PAYPAL = 'web_braintree_paypal';

export const subscriptionPaymentMethodMap = {
  [PAYMENT_PLATFORM_CARD_OLD]: PAYMENT_TYPE_CARD,
  [PAYMENT_PLATFORM_CARD]: PAYMENT_TYPE_CARD,
  [PAYMENT_PLATFORM_PAYPAL]: PAYMENT_TYPE_PAYPAL,
} as const;
